module.exports = __webpack_public_path__ + "static/media/SummaryCh13_A01378565.b1d8266a.pdf";